'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fab';
var iconName = 'duck-duck-go';
var width = 512;
var height = 512;
var ligatures = [];
var unicode = '';
var svgPathData = 'M512,259.8c0,122.1-83.1,224.5-195.1,252.2c-6.8-13.2-13.3-25.9-18.8-36.6c16.2,6.3,48.4,18.2,55.3,15.6 c9.4-3.7,7-80.1-3.5-82.5c-8.5-1.9-40.9,21.3-53.7,30.7l0.8,3.9c2,10.1,3.6,25.3,0.7,31.7c0,0.1,0,0.2-0.1,0.4 c-0.4,0.8-0.9,1.7-1.8,2.3c-7.2,4.8-27.1,7.3-37.7,4.8c-0.6-0.1-1.1-0.4-1.6-0.5c-17.4,10-50.4,28.2-56.4,24.7 c-8.2-4.8-9.4-68-8.2-83.5c0.8-11.7,41.5,7.3,61.2,17.3c4.3-4.2,15-6.9,24.5-7.9c-14.3-35.3-24.8-75.7-18.3-104.4l0,0 c8.9,6.3,68.3,26.7,97.9,26.1c29.6-0.6,78-18.9,72.7-33.6c-5.3-14.8-53.4,13-103.8,8.2c-37.2-3.5-43.8-20.5-35.6-32.8 c10.3-15.5,29.2,3,60.4-6.6c31.2-9.4,74.8-26.3,91-35.5c37.5-21.2-15.6-29.9-28.2-24.1c-11.9,5.6-53.2,16.2-72.3,20.9 c10.7-38.5-15.1-105.5-44-134.8c-9.4-9.5-23.8-15.6-40.2-18.7c-6.2-8.7-16.4-17-30.6-24.8c-27.6-14.7-59.3-19.9-90.1-14.9l-0.6,0.1 l-0.8,0.1h0.1c-3.8,0.7-6,2-8.9,2.5c3.8,0.4,17.6,7,26.4,10.6c-4.3,1.8-10.3,2.7-14.9,4.6c-1.8,0.2-3.5,0.7-5.2,1.4 c-4.3,2-7.6,9.5-7.5,13.1c21-2.1,52.1-0.7,74.9,6.2c-16.1,2.3-30.9,6.6-41.6,12.3c-0.4,0.2-0.7,0.5-1.2,0.7 c-1.4,0.5-2.7,1.1-3.8,1.7c-34.3,18.3-49.3,61.1-40.4,112.5c8.1,46.4,41.7,205.5,57.4,281.2C71.4,469.2,0,372.9,0,259.8 C0,116.3,114.6,0,256,0S512,116.3,512,259.8z M183.2,198.3c-10.5,0-19,8.6-19,19.3c0,10.6,8.5,19.3,19,19.3l0,0 c10.5,0,19-8.6,19-19.3C202.2,206.8,193.8,198.3,183.2,198.3z M310,189.6c-9-0.4-16.6,6.8-16.9,15.8c-0.4,9.2,6.7,16.8,15.6,17.2 c0.5,0,0.8,0,1.3,0c9,0,16.3-7.4,16.3-16.6C326.3,197,319.1,189.6,310,189.6L310,189.6z M188.7,161.8c0,0-14.3-6.6-28.2,2.3 c-13.9,8.8-13.4,17.9-13.4,17.9s-7.4-16.7,12.3-24.9C179.1,148.9,188.7,161.8,188.7,161.8L188.7,161.8z M319.9,160.5 c0,0-10.2-6-18.3-5.8c-16.4,0.2-20.8,7.5-20.8,7.5s2.7-17.5,23.7-13.9C311.3,149.4,317.1,154.1,319.9,160.5z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.faDuckDuckGo = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = ligatures;
exports.unicode = unicode;
exports.svgPathData = svgPathData;